import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "../common/axios";
import ShortcutLink from "../common/ShortcutLink";
import ListItemTrailResult from "../common/ListItemTrailResult";
import ButtonSelect from "../common/ButtonSelect";
import {BrandContext} from "../common/BrandContext";
import {UserContext} from "../common/UserContext";
import useCurrentShortcut from "../hooks/useCurrentShortcut";

const TeacherTrailResultsDashboardWidget = props => {
    const brandConfig = useContext(BrandContext);
    const {user, setUser} = useContext(UserContext);
    const [classesProps, setClassesProps] = useState([]);
    const [classId, setClassId] = useState();
    const [trailAssignmentId, setTrailAssignmentId] = useState();
    const [trailAssignments, setTrailAssignments] = useState();
    const [trialResults, setTrialResults] = useState();
    const [trailAssignmentsSelectProps, setTrailAssignmentsSelectProps] = useState({options: [], defaultValue: undefined});
    const {loadShortcutByUrl} = useCurrentShortcut();

    useEffect(() => {
        const currentClass = user.classes.findIndex(clazz => clazz.classId == user.classId);
        let newClassesProps = {
            defaultSelected: currentClass == -1 ? 0 : currentClass,
            options: []
        };
        user.classes.map(clazz => {
            let option = {
                value: clazz.classId,
                label: clazz.className
            }
            newClassesProps.options.push(option);
        });
        setClassesProps(newClassesProps);
    }, [user.classes]);

    useEffect(() => {
        if (classId !== undefined) {
            axios.get('/web/ui/trail/classAssignments/' + classId)
                .then(response => {
                    let newTrailAssignmentsSelectProps = {
                        defaultSelected: undefined,
                        options: []
                    };
                    response.data.map((trailAssignment, index) => {
                        let option = {
                            value: trailAssignment.pathwayAssignmentId,
                            label: trailAssignment.pathwayAssignmentName
                            // label: trailAssignment.pathwayAssignmentId
                        }
                        if (index === 0) newTrailAssignmentsSelectProps.defaultSelected = index;
                        newTrailAssignmentsSelectProps.options.push(option);
                    });
                    setTrailAssignments(response.data);
                    setTrailAssignmentsSelectProps(newTrailAssignmentsSelectProps);
                    if (newTrailAssignmentsSelectProps.defaultSelected != undefined) {
                        setTrailAssignmentId(newTrailAssignmentsSelectProps.options[newTrailAssignmentsSelectProps.defaultSelected].value);
                    }
                });
        }
    }, [classId]);

    useEffect(() => {
        if (trailAssignmentId !== undefined) {
            axios.get('/trail/trailResults.action?pathwayAssignmentId=' + trailAssignmentId)
                .then(response => {
                    setTrialResults(response.data.pathwayResults);
                });
        }
    }, [trailAssignmentId]);

    const handleChangeClass = selectedOption => {
        setClassId(selectedOption.value);
    }

    const handleChangeAssignment = selectedOption => {
        setTrailAssignmentId(selectedOption.value);
    }

    const createTrailFromDashBoard = () => {
        globalReactFunctions.createTrailFromDashboard = true;
        loadShortcutByUrl('/web/ui/view/teacherTrails');
    }

    return (
        <DashboardWidget
            title={
                <>
                    <svg className="ch-icon-sm" viewBox="0 0 128 128">
                        <use href="#pathways-icon"></use>
                    </svg>
                    <ShortcutLink className="ch-highlight" shortcutUrl={'/web/ui/view/teacherTrails'}>
                        <span>{brandConfig.taskName} Results</span>
                    </ShortcutLink>
                </>
            }
            headerObjects={[{componentName: 'Button', otherProps: {size: 'small', children: 'Create task', onClick: createTrailFromDashBoard}},
                {componentName: 'ButtonSelect', otherProps: {position: 'right', options: classesProps.options, title: 'Class', value: classesProps.defaultSelected !== undefined ? classesProps.options[classesProps.defaultSelected] : '', onChange: handleChangeClass}}]}
        >
                {trailAssignments !== undefined &&
                <>
                    <ButtonSelect
                        title={'Assignment'}
                        position={'right'}
                        options={trailAssignmentsSelectProps.options}
                        value={trailAssignmentsSelectProps.options[trailAssignmentsSelectProps.defaultSelected]}
                        onChange={data => {handleChangeAssignment(data);}}
                    />
                </>
                }
            <div className={'ch-dashboard-blk-body'}>
                {trialResults !== undefined &&
                    <table className={'ch-dashboard-widget-table ch-table'}>
                        <thead>
                        <tr>
                            <th>Students (<span className="errorMessage">*</span> task was skipped)</th>
                            <th>Date</th>
                            <th style={{width: '60%'}}>Results</th>
                        </tr>
                        </thead>
                        <tbody>
                            {Object.entries(trialResults.pathwayAssignmentUserMap).map(([key1, user], index) => {
                                let userResults = [];
                                Object.entries(trialResults.userResults).map(([key2, result]) => {
                                    if (user.userId === result.userId && !result.endStep) userResults.push(result);
                                });
                                userResults.sort((a, b) => {
                                    return a.stepSequence - b.stepSequence;
                                });
                                let completeDate;
                                userResults.map(result => {
                                    if (result.completeDate) completeDate = Date.parse(result.completeDate);
                                });
                                const userName = user.user.lastName + ', ' + user.user.firstName;
                                return <ListItemTrailResult key={index} userName={userName} userResults={userResults} completeDate={completeDate} />
                            })}
                        </tbody>
                    </table>
                }
                {trialResults === undefined &&
                    <div className="ch-list-item-disabled">No {brandConfig.tasksName} results</div>
                }
            </div>
        </DashboardWidget>
    )
}

export default TeacherTrailResultsDashboardWidget;